var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-close-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.667,0A11.667,11.667,0,1,0,23.333,11.667,11.686,11.686,0,0,0,11.667,0Zm3.92,14.35a.88.88,0,0,1,0,1.237.873.873,0,0,1-1.237,0L11.667,12.9,8.983,15.587a.873.873,0,0,1-1.237,0,.88.88,0,0,1,0-1.237l2.683-2.683L7.747,8.983A.874.874,0,0,1,8.983,7.747l2.683,2.683L14.35,7.747a.874.874,0,1,1,1.237,1.237L12.9,11.667Z",
    transform: "translate(2.333 2.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircle);
export default __webpack_public_path__ + "static/media/icon-close-circle.70d82f6a7eb3d021abc9a841446c6927.svg";
export { ForwardRef as ReactComponent };